import React from 'react'

import { compose, withProps } from 'recompose'
import {
  Circle,
  GoogleMap,
  Marker,
  withGoogleMap,
  withScriptjs
} from 'react-google-maps'
import _ from 'lodash'
import { GOOGLE_MAP_API_URL } from '../../../../config'

export const LocationMap = ({ heroConfigs, locationList, hero }) => {
  const renderRadius = (type) => {
    if (hero.configByHero) {
      return hero.radius
    } else {
      const result = _.find(heroConfigs, (item) => {
        return item.heroType === type
      })
      return !_.isUndefined(result) ? result.radius : null
    }
  }

  return (
    <GoogleMap
      defaultZoom={12}
      center={{
        lat: parseFloat(locationList[0].lat || 0),
        lng: parseFloat(locationList[0].lng || 0)
      }}>
      {locationList &&
        locationList.map((location, index) => (
          <div key={index.toString()}>
            <Marker
              title={location.address}
              position={{
                lat: parseFloat(location.lat),
                lng: parseFloat(location.lng)
              }}
            />
            <Circle
              options={{
                strokeColor: 'transparent',
                fillColor: 'green',
                fillOpacity: 0.1
              }}
              center={{
                lat: parseFloat(location.lat),
                lng: parseFloat(location.lng)
              }}
              radius={
                !_.isUndefined(hero) &&
                !_.isNull(hero) &&
                renderRadius(hero.heroType)
              }
            />
          </div>
        ))}
    </GoogleMap>
  )
}

export default compose(
  withProps({
    googleMapURL: GOOGLE_MAP_API_URL,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `50vh` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  withScriptjs,
  withGoogleMap
)(LocationMap)



// WEBPACK FOOTER //
// ./src/pages/Heroes/components/PickLocation/index.js